import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response) => {
    switch (method) {
        case handlers.GET_COLORS_BY_SPECTRO_DELTA:
            if (!responseHelper.isGetColorsBySpectroFormatValid(response)) {
                return [
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.SEARCHING_MODAL
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.SEARCHING_MODAL
                    }
                },
                {
                    type: actionTypes.SAVE_SPECTRO_FORMULAS,
                    payload: {
                        formulas: response.data.colors
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
